export default {
  'Add Cut': 'Ajouter clips',
}